<template>
  <main-content>
    <div v-if="status == 'success'">
      <page-title title_text="درگاه پرداخت" icon="gateways"></page-title>
<!--      <div class="row mx-auto text-center">-->
<!--        <div class="col-12 col-md my-2" @click="gotoTab(1)">-->
<!--          <div-->
<!--            :class="[-->
<!--              'bg-white shadow-sm p-2 h-100 gateway-tab',-->
<!--              currentTab === 1 ? 'border border-success active-tab' : '',-->
<!--            ]"-->
<!--            style="border-radius: 10px; border-width: 2px !important"-->
<!--          >-->
<!--            <svg-->
<!--              xmlns="http://www.w3.org/2000/svg"-->
<!--              height="24"-->
<!--              viewBox="0 0 24 24"-->
<!--              width="24"-->
<!--              fill="#a0a0a0"-->
<!--            >-->
<!--              <path d="M0 0h24v24H0V0z" fill="none" />-->
<!--              <path-->
<!--                d="M5 6h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1zm15.16 1.8c-.09-.46-.5-.8-.98-.8H4.82c-.48 0-.89.34-.98.8l-1 5c-.12.62.35 1.2.98 1.2H4v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-5h4v5c0 .55.45 1 1 1s1-.45 1-1v-5h.18c.63 0 1.1-.58.98-1.2l-1-5zM12 18H6v-4h6v4z"-->
<!--              />-->
<!--            </svg>-->
<!--            <span :class="['px-2', currentTab === 1 ? 'text-success' : 'text-secondary']">-->
<!--              اینترنتی (IPG)-->
<!--            </span>-->
<!--          </div>-->
<!--          <div class="triangle-down d-none d-md-block" v-if="currentTab === 1"></div>-->
<!--        </div>-->
<!--      </div>-->
      <div v-if="currentTab === 1">
        <div v-if="pardakhtyari_count > 0">
          <div
            class="mt-3 d-flex align-items-center bg-white shadow-sm p-3 gw-toolbar"
            style="border-radius: 10px"
          >
            <div class="ml-auto">
              <div class="form-group px-2 my-0 d-flex">
                <input
                  class="form-control"
                  type="text"
                  placeholder=" جستجو "
                  style="border-radius: 20px"
                  v-model="search_gateway_title"
                />
                  <select
                      class="form-control kt-selectpicker mx-2"
                      v-model="settlement_type"
                      id="filter_status"
                  >
                      <option
                          :value="null"
                          v-text="$t('terminal_settlement_type.all')"
                      >
                      </option>
                      <option
                          v-bind:key="index"
                          v-for="(type, index) in settlement_types"
                          v-bind:value="type.value"
                          :selected="settlement_type === type.value"
                      >
                          {{ type.name }}
                      </option>
                  </select>
              </div>
            </div>
            <div class="form-group px-2 my-0">
              <router-link
                to="/gateways/create"
                class="btn btn-success"
                style="border-radius: 20px"
              >
                ثبت درگاه
              </router-link>
            </div>
          </div>
          <div class="row mt-3">
            <gateway
              v-for="(gateway, index) in ekhtesasiSearch"
              :gateway="gateway"
              :gateway_type="0"
              :key="index"
              :gindex="index"
              :gtype="gateway.type"
              :gsquence="gateway.type"
              @sign-contract="openContract"
            ></gateway>
          </div>
        </div>
        <description
          v-else
          link_url="/gateways/create"
          learn_more_url="https://paystar.ir/ipg"
          info_title="درگاه پرداخت پرداخت‌یاری ، بستری امن و پایدار برای تراکنش‌های شما"
          :info_list="[
            'ترمینال اختصاصی همراه با نمایش نام و لوگو',
            'تسویه روزانه',
            'مسیردهی هوشمند',
            'تسهیم',
            'اشتراک کارمزد بین پذیرنده و پرداخت کننده',
            'بررسی شماره کارت مشتریان',
          ]"
        >
          <template v-slot:svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="48"
              viewBox="0 0 24 24"
              width="48"
              fill="#00bea5"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path
                d="M5 6h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1zm15.16 1.8c-.09-.46-.5-.8-.98-.8H4.82c-.48 0-.89.34-.98.8l-1 5c-.12.62.35 1.2.98 1.2H4v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-5h4v5c0 .55.45 1 1 1s1-.45 1-1v-5h.18c.63 0 1.1-.58.98-1.2l-1-5zM12 18H6v-4h6v4z"
              />
            </svg>
          </template>
        </description>
      </div>
    </div>
    <contract-modal ref="contract_modal" @signed="onContractSigned" @enamad-error="onEnamadError"></contract-modal>
  </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import { mapGetters } from "vuex";
import {
  gatewayStatus,
  gatewayStatusStr,
  gatewayVariant,
} from "@/constants/gatewayStatus";
import {
  gatewayTypes,
  gatewayTypeStr,
  gatewayTypeUpdateUrl,
  gatewayTypeVariant,
} from "@/constants/gatewayTypes";
import { STAR_CARD_REGISTER } from "@/common/config";
import { getToken } from "@/common/jwt.service.js";
import { SHOP_LOGIN } from "@/common/config";
import gateway from "@/pages/gateways/gateway";
import ContractModal from "@/pages/gateways/components/contract-modal";
import Description from "@/pages/gateways/description";
import PageTitle from "@/components/main/components/pageTitle";
import {  terminalSettlementTypes } from '@/constants/TerminalSettlementType';

export default {
  name: "gateways",
  components: { PageTitle, Description, MainContent, gateway, ContractModal },
  data() {
    return {
      search_gateway_title: "",
      settlement_type: null,
      settlement_types: terminalSettlementTypes,
      currentTab: 1,
        gatewayStatus: gatewayStatus,
        gatewayTypes: gatewayTypes,
        pardakhtyari_count: 0,
        pardakhtyari_services: [],
        ekhtesasi: [],
        isHover: false,
    };
  },
  methods: {
    openContract(shop_id) {
      this.$refs.contract_modal.open(shop_id);
    },
    onContractSigned() {
      this.$store.dispatch("gateway/fetch");
    },
    onEnamadError(body) {
      this.$router.push(`/gateways/update/${body.data.shop_id}/register-enamad`);
    },
    gotoTab(selected_tab) {
      this.search_gateway_title = "";
      this.$store.dispatch("gateway/gatewayTab", selected_tab)
      this.currentTab = this.get_gateway_tab;
    },
    variant(status) {
      return gatewayVariant(status);
    },
    typeVariant(type) {
      return gatewayTypeVariant(type);
    },
    statusStr(status) {
      return gatewayStatusStr.get(status);
    },
    gatewayType(type) {
      return gatewayTypeStr.get(type);
    },
    updateUrl(type) {
      return gatewayTypeUpdateUrl(type);
    },
    getLink(hashid) {
      return "/profile/namad/" + hashid;
    },

    getReportLink(hashid) {
      return "/gateways/transactions-report/" + hashid;
    },
    createCartGateway() {
      let phone;
      let first_name;
      let last_name;
      if (Object.keys(this.current_user).length > 0) {
        phone = this.current_user.phone;
        first_name = this.current_user.first_name;
        last_name = this.current_user.last_name;
      } else {
        this.$store.dispatch("user/fetchCurrent").finally(() => {
          phone = this.current_user.phone;
          first_name = this.current_user.first_name;
          last_name = this.current_user.last_name;
        });
      }

      let form = document.createElement("form");
      form.setAttribute("style", "display: none;");

      let input_phone = document.createElement("input");
      input_phone.setAttribute("value", phone);
      input_phone.setAttribute("name", "phone");

      let input_first_name = document.createElement("input");
      input_first_name.setAttribute("value", first_name);
      input_first_name.setAttribute("name", "first_name");

      let input_last_name = document.createElement("input");
      input_last_name.setAttribute("value", last_name);
      input_last_name.setAttribute("name", "last_name");

      form.appendChild(input_phone);
      form.appendChild(input_first_name);
      form.appendChild(input_last_name);
      form.setAttribute("action", STAR_CARD_REGISTER);
      form.setAttribute("method", "POST");
      document.body.appendChild(form);
      form.submit();
    },
    redirectToShop() {
      let token = getToken();
      let link = document.createElement("a");
      link.href = SHOP_LOGIN + "/panel/" + token;
      document.body.appendChild(link);
      link.click();
    },
  },
  watch: {
    status: function (val) {      
      if (val == "success") {
        for (let g in this.gateways) {
          
          if (this.gateways[g].gateway_type === 0) {
            if(this.gateways[g].type === 2 || this.gateways[g].type === 4){
              ++this.pardakhtyari_count;
              this.ekhtesasi.push(this.gateways[g])
            }
          }
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch("gateway/fetch");
    this.currentTab = this.get_gateway_tab
  },

  computed: {
    ...mapGetters("gateway", ["gateways", "hasCartGateway", "status","get_gateway_tab"]),
    ...mapGetters("user", [
      "is_authenticated",
      "is_authenticated_pending",
      "profile_completed",
      "current_user",
    ]),
    gateways_after_search() {
      let result = [];
      if (this.status == "success") {
        for (let g in this.gateways) {
          if (this.gateways[g].title.includes(this.search_gateway_title)) {
              result.push(this.gateways[g]);
          }
        }
      }


      return result;
    },
    ekhtesasiSearch() {
      let result = [];
      if (this.status == "success") {
        for (let g in this.ekhtesasi) {
          if (this.ekhtesasi[g].title.includes(this.search_gateway_title)) {
              if (this.currentTab === 1) {
                  if (this.settlement_type && this.gateways[g].settlement_type === parseInt(this.settlement_type)) {
                      result.push(this.ekhtesasi[g]);
                  }else if(!this.settlement_type) {
                      result.push(this.ekhtesasi[g]);
                  }
              }else if(this.currentTab !== 1) {
                  result.push(this.ekhtesasi[g]);
              }
          }
        }
      }

      return result;
    },
  },
};
</script>

<style>
@media (max-width: 767.98px) {
  .gw-toolbar {
    flex-wrap: wrap;
    gap: 0.6rem;
  }
  .gw-toolbar > div {
    flex: 1 1 100%;
    margin: 0 !important;
  }
  .gw-toolbar > div > .form-group,
  .gw-toolbar .form-group {
    padding: 0 !important;
  }
  .gw-toolbar .btn {
    width: 100%;
  }
}
</style>
